import { DateSplit } from "./DateSplit";

export class DateRangeParameter {
  dateFrom: DateSplit;
  dateTo: DateSplit;

  constructor();
  constructor(obj: DateRangeParameter);
  constructor(obj?: DateRangeParameter) {
    if (obj != undefined){
      this.dateFrom = new DateSplit(new Date(obj.dateFrom.day), obj.dateFrom.hour, obj.dateFrom.minute)
      this.dateTo = new DateSplit(new Date(obj.dateTo.day), obj.dateTo.hour, obj.dateTo.minute)
    }
    else
    {
      this.dateFrom = new DateSplit(new Date(new Date().setDate(new Date().getDate() - 7)), '00', '00');
      this.dateTo = new DateSplit(new Date(), '23', '59');
    }
  }

  public clone(): DateRangeParameter{
    let cloned = new DateRangeParameter()

    cloned.dateFrom = this.dateFrom.clone()
    cloned.dateTo = this.dateTo.clone()

    return cloned;
  }
}
